import { render, staticRenderFns } from "./JxcVoucher.vue?vue&type=template&id=20b4bc7a&scoped=true"
import script from "./JxcVoucher.vue?vue&type=script&lang=js"
export * from "./JxcVoucher.vue?vue&type=script&lang=js"
import style0 from "./JxcVoucher.vue?vue&type=style&index=0&id=20b4bc7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4bc7a",
  null
  
)

export default component.exports